import FeatureGates from '@atlaskit/feature-gate-js-client';
import { ApplicationData } from '../../../../utilities/applications';
import { AnalyticsClient } from '../../../../utilities/analytics/analytics-web-client';
import { checkFeatureGate } from '../../../../utilities/feature-flags/feature-gate';
import { AidFrontendFeatureGate } from '../../../../providers/FeatureGates';

const TWCG_786_EXPERIMENT_KEY = 'twcg-786-prioritise-sso-on-login-page';

/** Guard: fire exposure event at most once per page load (resets on full reload). */
let twcg786ExposureEventFired = false;

export function isTWCG786EnabledAndVariationCohort(
  applicationData: ApplicationData,
  analyticsClient: AnalyticsClient | undefined
): boolean {
  try {
    const twcg768GateEnabled = checkFeatureGate(
      AidFrontendFeatureGate.TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE_GATE
    );

    if (!twcg768GateEnabled) {
      return false;
    }

    const cohortValue = FeatureGates.getExperimentValue(
      TWCG_786_EXPERIMENT_KEY,
      'cohort',
      'not-enrolled'
    ) as 'variation' | 'control' | 'not-enrolled';

    if (analyticsClient && !twcg786ExposureEventFired) {
      twcg786ExposureEventFired = true;
      analyticsClient.trackingEvent({
        page: 'login-page',
        action: 'exposed',
        subject: TWCG_786_EXPERIMENT_KEY,
        attributes: {
          flagKey: TWCG_786_EXPERIMENT_KEY,
          group: cohortValue,
          application: applicationData?.coreApplication,
          experience: applicationData?.experience,
        },
      });
    }

    return twcg768GateEnabled && cohortValue === 'variation';
  } catch (error) {
    analyticsClient?.operationalEvent({
      page: 'login-page',
      action: 'failed',
      subject: TWCG_786_EXPERIMENT_KEY,
      attributes: {
        flagKey: TWCG_786_EXPERIMENT_KEY,
        application: applicationData?.coreApplication,
        experience: applicationData?.experience,
        errorName: error?.name,
        errorStack: error?.stack,
        errorMessage: error?.message,
        errorCode: error?.code,
      },
    });
    return false;
  }
}
